import { h, render, Fragment } from "preact"
import { Connect, Provider } from "redux-zero/preact";
import { searchStore } from "./store";
import searchActions from "./searchActions";
import { SuggestionList } from "./SuggestionList";
import { SuggestionProduct } from "./SuggestionProduct";
import { CollectionList } from "./CollectionList";
import Skeleton from 'preact-loading-skeleton';
import { ProductSkeleton } from "./ProductSkeleton";
import { useEffect } from "preact/hooks";


export const LiveSearch = ({
                             products,
                             suggestions,
                             collections,
                             query,
                             isFetching,
                             setQuery,
                             setIsFetching,
                             setSearchSuggestion,
                             setIsSuggestionFetching,
                             isSuggestionFetching
                           }) => {
  
  useEffect(() => {
    document.body.addEventListener("click", handleSearchDropClose);
    return function () {
      document.body.removeEventListener('click', handleSearchDropClose)
    }
  }, [])
  
  function handleSearchDropClose(e) {
    //check if click is inside of the search drop
    if (e.target.closest('.search-drop')
      || e.target.classList.contains('site-search-form__input')
      || e.target.closest('.search-open-close__opener')
      || e.target.classList.contains('search-open-close__opener')) {
      return;
    }
    document.body.classList.remove('search-drop--active');
  }
  
  function renderResults() {
    return (
      <div class="row">
        <div class="col-md-3 col-lg-2 text-brand-black">
          { suggestions.length > 0 && !isSuggestionFetching &&
          <SuggestionList setIsFetching={ setIsFetching }
                          setSearchSuggestion={ setSearchSuggestion }
                          setQuery={ setQuery }
                          query={ query }
                          suggestions={ suggestions }/> }
          { isFetching && <Skeleton count={ 5 }/> }
          { collections.length > 0 && !isFetching && <CollectionList collections={ collections } query={ query }/> }
        </div>
        <div class="col-md-9 col-lg-10">
          <div class="row search-drop__item-holder">
            { isFetching && <ProductSkeleton/> }
            { !isFetching && products.map((product, index) => index < 4 && (
              <SuggestionProduct key={ product.id } product={ product }/>)
            ) }
          </div>
        </div>
      </div>
    )
  }
  
  function renderNoResults() {
    return (
      <div class={ 'h3 text-center' }>{ `Sorry, nothing found for "${ query }"` }</div>
    )
  }
  
  return (
    <div class="container">
      { products.length > 0 && renderResults() }
      { !isFetching && !products.length > 0 && renderNoResults() }
    </div>
  )
}

const searchDrop = document.querySelector('.search-drop')
if (searchDrop) {
  render(
    <Provider store={ searchStore }>
      <Connect actions={ searchActions }>
        { (props) => (
          <LiveSearch { ...props } ref={ (element) => {
            window.search = element
          } }/>
        ) }
      </Connect>
    </Provider>, searchDrop);
}
